import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Hero, InfoStrip } from "./components/Hero";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Gallery } from "./components/Gallery";
import { InstagramFeed } from "./components/InstagramFeed";
import { QualityBanner, CustomProject, EuropeDelivery } from "./components/Statements";
import { LargeProjects } from "./components/LargeProjects";
import { Reviews } from "./components/Reviews";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App bg-ink font-body">
      <Navbar />
      <main>
        <Hero />
        <InfoStrip />
        <About />
        <Services />
        <Gallery />
        <InstagramFeed />
        <QualityBanner />
        <CustomProject />
        <EuropeDelivery />
        <LargeProjects />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
